

module.exports = __webpack_require__.stylable.create(
    "Widget2128011436",
    {"classes":{"root":"Widget2128011436__root","rcptext":"Widget2128011436__rcptext"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Widget2128011436",
    null
);
